import { RSAA } from 'redux-api-middleware';
import fetch from 'isomorphic-fetch';
import api from '../../api';

// ------------------------------------
// Constants
// ------------------------------------
const LOAD_REQUEST = 'farmakom/singlePage/LOAD_REQUEST';
const LOAD_SUCCESS = 'farmakom/singlePage/LOAD_SUCCESS';
const LOAD_FAILURE = 'farmakom/singlePage/LOAD_FAILURE';

const LOAD_ABOUT_US_REQUEST = 'farmakom/singlePage/LOAD_ABOUT_US_REQUEST';
const LOAD_ABOUT_US_SUCCESS = 'farmakom/singlePage/LOAD_ABOUT_US_SUCCESS';
const LOAD_ABOUT_US_FAILURE = 'farmakom/singlePage/LOAD_ABOUT_US_FAILURE';

// ------------------------------------
// Actions
// ------------------------------------

// API CALL
export function loadPageBySlug(params) {
  return {
    [RSAA]: {
      ...api.getPageBySlug(params.slug),
      types: [LOAD_REQUEST, LOAD_SUCCESS, LOAD_FAILURE],
    },
  };
}

export function loadAboutUs() {
  return {
    [RSAA]: {
      ...api.getPageBySlug('chi-siamo'),
      types: [
        LOAD_ABOUT_US_REQUEST,
        LOAD_ABOUT_US_SUCCESS,
        LOAD_ABOUT_US_FAILURE,
      ],
    },
  };
}

// ------------------------------------
// Reducer
// ------------------------------------

const initialState = {
  loading: false,
  error: '',
  data: {},
  aboutUsData: {
    content: '',
  },
};

export default function singlePageReducer(state = initialState, action) {
  switch (action.type) {
    case LOAD_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };
    case LOAD_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.message,
      };
    case LOAD_ABOUT_US_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case LOAD_ABOUT_US_SUCCESS:
      return {
        ...state,
        loading: false,
        aboutUsData: action.payload,
        error: null,
      };
    case LOAD_ABOUT_US_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.message,
      };
    default:
      return state;
  }
}
